export * from "./outofstock-product";